module.exports = "https://cdn-static.kwai.net/kos/s101/nlav11312/shop/c_krn/krn-web/images/local_product_benefit.931c7f4137.png";